import axios from "@/axios";

const state = {
    token: localStorage.getItem('user-token') || '',
    status: '',
}

const getters = {
    isAuthenticated: state => !!state.token,
    authStatus: state => state.status,
}

const actions = {
    "AUTH_REQUEST": ({commit, dispatch}, user) => {
        return new Promise((resolve, reject) => { // The Promise used for router redirect in login
            commit("AUTH_REQUEST")
            delete axios.defaults.headers["Authorization"];
            axios({url: '/get-token/', data: user, method: 'POST',})
                .then(resp => {
                    const token = resp.data.token
                    axios.defaults.headers["Authorization"] = "Token "+token
                    localStorage.setItem('user-token', token) // store the token in localstorage
                    commit("AUTH_SUCCESS", token)
                    // window.document.location.reload();
                    resolve(resp)
                })
                .catch(err => {
                    commit("AUTH_ERROR", err)
                    localStorage.removeItem('user-token') // if the request fails, remove any possible user token if possible
                    reject(err)
                })
        })
    },
    "AUTH_LOGOUT": ({commit}) => {
        localStorage.removeItem('user-token')
        commit("AUTH_LOGOUT")
    }
}

const mutations = {
    "AUTH_REQUEST": (state) => {
        state.status = 'loading'
    },
    "AUTH_SUCCESS": (state, token) => {
        state.status = 'success'
        state.token = token
    },
    "AUTH_ERROR": (state) => {
        state.status = 'error'
        state.token = ''
    },
    "AUTH_LOGOUT": (state) => {
        state.status = ''
        state.token = ''
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}
